import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_WIDTH } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  loaderWrapper: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // backgroundColor: 'rgba(0, 0, 0, 0.1)',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 3,
  },
}));
